module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-table"
  }, [_c('div', [_c('h2', {
    staticStyle: {
      "font-weight": "bold"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.table.title)
    }
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._v("\n      WKN:" + _vm._s(_vm.table.config.wkn) + " | ISIN: " + _vm._s(_vm.table.config.isin) + "\n    ")])]), _vm._v(" "), _c('table', [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.table.data), function(row, key) {
    return _c('tr', [_c('td', [_vm._v("\n        " + _vm._s(row.positive[0].label) + "\n      ")]), _vm._v(" "), _c('td', [_vm._l((row.positive), function(entry, entryKey) {
      return [_vm._v("\n          " + _vm._s(entry.timestamp && entry.values.length !== 0 ? _vm.getTimeStamp(entry.timestamp) + ' | ' : '') + " " + _vm._s(entry.values.length > 0 ? entry.values.join(', ') : '—') + "\n\n          "), _c('br')]
    })], 2), _vm._v(" "), _c('td', [_vm._l((row.negative), function(entry, entryKey) {
      return [_vm._v("\n          " + _vm._s(entry.timestamp && entry.values.length !== 0 ? _vm.getTimeStamp(entry.timestamp) + ' | ' : '') + " " + _vm._s(entry.values.length > 0 ? entry.values.join(', ') : '—') + "\n          "), _c('br')]
    })], 2)])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("positiv")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("negativ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96750ef4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmc-export/TmcListTable.vue
// module id = 710
// module chunks = 0